import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { AiSparkle } from "@/components/common/AiSparkle";
import { useConcierge } from "@/context/ConciergeContext";

const TEASER_KEY = "757-concierge-teaser";

/** Animated AI orb in the corner (every page except admin) + a one-time teaser bubble. */
export const ConciergeLauncher = () => {
  const { open, openWith } = useConcierge();
  const { pathname } = useLocation();
  const [teaser, setTeaser] = useState(false);
  useEffect(() => {
    let seen = false;
    try {
      seen = sessionStorage.getItem(TEASER_KEY) === "1";
    } catch {
      seen = false;
    }
    if (seen) return undefined;
    const t = setTimeout(() => setTeaser(true), 3500);
    return () => clearTimeout(t);
  }, []);
  const hideTeaser = () => {
    setTeaser(false);
    try {
      sessionStorage.setItem(TEASER_KEY, "1");
    } catch {
      /* ignore */
    }
  };
  if (open || pathname.startsWith("/admin") || pathname.startsWith("/crm")) return null;

  return (
    <div className="fixed bottom-24 right-4 z-50 flex flex-col items-end gap-3 lg:bottom-6 lg:right-6" data-testid="concierge-launcher">
      {teaser && (
        <div className="relative mb-2 max-w-[230px] animate-rise-in rounded-2xl rounded-br-sm bg-white px-4 py-3 text-[13.5px] text-ink shadow-[0_20px_50px_-15px_rgba(0,0,0,0.45)]" data-testid="concierge-teaser">
          <button type="button" onClick={hideTeaser} aria-label="Hide" data-testid="concierge-teaser-close" className="absolute -right-2 -top-2 grid h-6 w-6 place-items-center rounded-full bg-ink text-white"><X className="h-3.5 w-3.5" /></button>
          <button type="button" onClick={() => { hideTeaser(); openWith(); }} data-sfx="chime" className="text-left" data-testid="concierge-teaser-open">
            <span className="font-medium">Hi! I'm your AI home concierge.</span> Ask how far a home is from base, a school or your favorite Italian spot.
          </button>
        </div>
      )}
      <button type="button" onClick={() => { hideTeaser(); openWith(); }} aria-label="Open the AI home concierge" data-sfx="chime" data-testid="concierge-open"
        className="group relative h-16 w-16 shrink-0 rounded-full">
        <span className="absolute inset-0 animate-ping-slow rounded-full bg-brass/40" />
        <span className="ai-glow absolute inset-0 rounded-full">
          <span className="grid h-full w-full place-items-center rounded-full bg-ink transition-transform group-hover:scale-105">
            <AiSparkle className="h-8 w-8" />
          </span>
        </span>
      </button>
    </div>
  );
};
